import { CircularProgress } from "@material-ui/core";
import React from "react";

export function TableLoadingIndicator() {
  return (
    <div className="table-loading-indicator" role="status" aria-live="polite">
      <CircularProgress size={36} thickness={4} />
      <span>Adatok betöltése…</span>
    </div>
  );
}
